import { atom } from "jotai";
import {
    AccountPanelView,
    FileListStatementType,
    FileStatusOptions,
    SelectedAccountRow,
} from "./Labeling.types";
import { Account } from "@/entities/DataAssociation/Account.model";
import { DraftEdits } from "@/entities/DataAssociation/Draft.model";

export const AccountPanelViewAtom = atom<AccountPanelView>(
    AccountPanelView.ACCOUNT_LIST,
);
export const selectedAccountAtom = atom<SelectedAccountRow | null>(null);
export const showReadableLabelAtom = atom<boolean>(true);
export const draftEditsAtom = atom<DraftEdits>({});
export const newAccountsAtom = atom<Account[]>([]);
export const showCommitPanelAtom = atom<boolean>(false);
export const fileListStatusOptionsAtom = atom<FileStatusOptions>(
    FileStatusOptions.UNLABELED,
);
export const fileListStatementTypeAtom = atom<FileListStatementType>("all");
